import {
  Box,
  ColorProps,
  HStack,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import React from 'react'

export interface LabelValuePairProps {
  children?: React.ReactNode
  emptyPlaceholder?: string
  icon?: JSX.Element
  label: string
  labelColor?: ColorProps['color']
  mobile?: boolean
  value?: string | number | JSX.Element | (JSX.Element | undefined)[]
  whiteSpace?:
    | 'break-spaces'
    | 'pre-line'
    | 'nowrap'
    | 'normal'
    | 'pre'
    | 'pre-wrap'
  width?: string | number
  wrapItems?: boolean
}

export const LabelValuePair = ({
  children,
  emptyPlaceholder,
  icon,
  label,
  labelColor = 'neutral.50',
  mobile,
  value,
  whiteSpace = 'pre-line',
  width = '100%',
  wrapItems = false,
}: LabelValuePairProps) => {
  const isMobileBreakpoint = useBreakpointValue({ base: true, sm: false })

  return (
    <HStack alignItems="flex-start" spacing={5} width={width}>
      {icon && <Box>{icon}</Box>}
      <Stack
        alignItems="baseline"
        direction={['row', mobile ? 'row' : 'column']}
        flexWrap={wrapItems ? 'wrap' : 'initial'}
        spacing={1}
        width="100%"
      >
        <Text color={labelColor} textStyle="text.md" whiteSpace={whiteSpace}>
          {label}
          {(isMobileBreakpoint || mobile) && label ? ':' : ''}
        </Text>

        {typeof children === 'string' ? (
          <Text as="span">{children}</Text>
        ) : (
          children || (
            <Text
              as="div"
              minW="fit-content"
              textStyle="text.md"
              whiteSpace="pre-line"
              wordBreak="break-all"
            >
              {value || emptyPlaceholder || '-'}
            </Text>
          )
        )}
      </Stack>
    </HStack>
  )
}
